var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TSelect',{staticClass:"m-0",attrs:{"label":_vm.label,"placeholder":"Select","options":_vm.boxTypeList,"value":_vm.valueSelected,"selectOptions":_vm.selectOptions},on:{"select":_vm.onSelect}})
}
var staticRenderFns = []

export { render, staticRenderFns }